import { render, staticRenderFns } from "./yanzhengma.vue?vue&type=template&id=293b70e0&scoped=true&"
import script from "./yanzhengma.vue?vue&type=script&lang=js&"
export * from "./yanzhengma.vue?vue&type=script&lang=js&"
import style0 from "./yanzhengma.vue?vue&type=style&index=0&id=293b70e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293b70e0",
  null
  
)

export default component.exports